import api from './api';
import pick from 'lodash/pick';

/**
 * @param {{
 *  task_type_id: string
 *  rubric_id: string
 *  rubric_text: string
 *  rubric_audio_id: string
 * }} rubric
 * @returns {Promise<{
 *  updated: boolean,
 *  rubric_id: string
 *  rubric_text: string
 *  rubric_audio_id: string
 *  skill_id: string
 *  phase: string
 *  task_type_id: string
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Rubrics-postRubrics
 */
export default async function createRubric(rubric) {

    const { data } = await api.post(
        `rubrics`,
        pick(rubric, [
            'rubric_text',
            'rubric_audio_id',
            'phase',
            'task_type_id',
            'skill_id',
            'level_id'
        ])
    );

    return data;
}